import type { SlugDetail } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';

export type ProductDetail = NonNullable<SlugDetail['App\\Models\\Product']>;

/** Props of the product page sections: the slug response of the product. */
export type ProductSectionProps = { locale: string; product: ProductDetail };

/**
 * Anchors shared by the sections (links in the buy box and the compatibility notice). `description`,
 * `reviews` and `downloads` are the tab panels – a link to one opens that tab.
 */
export const PRODUCT_ANCHORS = {
  description: 'popis',
  compatibility: 'kompatibilita',
  reviews: 'hodnotenia',
  downloads: 'na-stiahnutie',
} as const;
